Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
var Notifications_1 = require("../components/Notifications");
var mapStateToProps = function (_a) {
    var notifications = _a.notifications;
    return { notifications: notifications };
};
exports.default = react_redux_1.connect(mapStateToProps)(Notifications_1.default);
